import {
  labelConfigSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {useSelector} from '../../../store.js'
import {
  AMAZON_SFP,
  AUSTRALIA_POST,
  CANADA_POST,
  DHL_ECOMMERCE,
  ENDICIA,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SHIPPO,
  UPS,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import ShipperOptions from '../../../data/shipperOptions.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

export const VALID_DELIVERY_CONFIRMATION_SHIPPER_TYPES = [
  AMAZON_SFP,
  AUSTRALIA_POST,
  CANADA_POST,
  DHL_ECOMMERCE,
  ENDICIA,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SHIPPO,
  UPS,
  USPS_SHIP,
]

export function deliveryConfirmationLabelPropertiesFunc(shipperType) {
  return VALID_DELIVERY_CONFIRMATION_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__delivery_confirmation`]
    : []
}

export function fedexDeliveryConfirmationOptionsSelector(
  state,
  {labelInfoID, shipperType},
) {
  const shipperOptions = ShipperOptions[shipperType]
  const labelConfig = labelConfigSelector(state, {labelInfoID})

  const isResidential = !!labelConfig.recipient_address_is_residential

  if (isResidential) {
    return shipperOptions.delivery_confirmation
  }

  return shipperOptions.delivery_confirmation.filter(
    ({value}) =>
      (shipperType === FEDEX && value !== 'INDIRECT') ||
      (shipperType === FEDEX_360 && value !== 'SIG'),
  )
}

export function deliveryConfirmationOptionsSelector(
  state,
  {labelInfoID, shipperType},
) {
  const shipperOptions = ShipperOptions[shipperType]

  if ([FEDEX, FEDEX_360].includes(shipperType)) {
    return fedexDeliveryConfirmationOptionsSelector(state, {
      labelInfoID,
      shipperType,
    })
  }

  return shipperOptions.delivery_confirmation
}

export default function DeliveryConfirmation() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = DeliveryConfirmation.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const options = useSelector((state) =>
    deliveryConfirmationOptionsSelector(state, {labelInfoID, shipperType}),
  )

  return (
    <ConfigSelect
      label="Delivery Confirmation"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      noEmptyOption={AMAZON_SFP === shipperType}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      options={options}
    />
  )
}

DeliveryConfirmation.propertySpecList = [
  {
    validShipperTypes: VALID_DELIVERY_CONFIRMATION_SHIPPER_TYPES,
    labelPropertiesFunc: deliveryConfirmationLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
